<template>
  <div class="checkout">
    <Header />

    <div class="breadcrumb-area gray-bg">
      <div class="container">
        <div class="breadcrumb-content">
          <ul>
            <li><router-link to="/">Home</router-link></li>
            <li class="active">Checkout</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="checkout-area pt-25 pb-25">
      <div class="container">
        <h3 class="page-title">Event checkout</h3>

				<template v-if="event.total_revenue != null">
					<div class="row">
						<div class="col-lg-8">
							<div class="grand-totall bg-white">
								<div class="title-wrap mb-4">
									<h4 class="cart-bottom-title section-bg-gary-cart">
										Billing details
									</h4>
								</div>

								<div class="row">
									<div class="col-lg-6 form-group">
										<label>Full names</label>
										<input class="form-control input-sm rounded" v-model="paymentData.customer.name" type="text"/>
									</div>
									<div class="col-lg-6 form-group">
										<label>Phone Number</label>
										<input class="form-control input-sm rounded" v-model="paymentData.customer.phone_number" type="number"/>
									</div>
								</div>

								<div class="row">
									<div class="col-lg-12 form-group">
										<label>Email</label>
										<input class="form-control input-sm readonly rounded" v-model="paymentData.customer.email" type="email"/>
									</div>
								</div>

								<div class="title-wrap my-4">
									<h4 class="cart-bottom-title section-bg-gary-cart">
										Payment options``
									</h4>
								</div>

								<div class="row">
									<div class="col-lg-12 form-group">
										<div class="shop-widget ">
												<div class="sidebar-list-style">
														<ul>
																<li class="p-4 content-box">
																	<input type="radio" ref="mpesa_checkout" @click="changePaymentMethod('mpesa')" :checked="mpesaCheckout ? true : false">
																	<img src="../assets/img/logo/mpesa.svg" height="32px">																																
																</li>
																
																<li class="p-4 content-box mt-4">
																		<div class="row">
																			<div class="col-lg-6 col-12">
																				<input type="radio" ref="pesapal_checkout" @click="changePaymentMethod('pesapal')" :checked="pesapalCheckout ? true : false">
																				<img src="../assets/img/logo/pesapal.png" height="32px"> 
																			</div>
																			<div class="col-lg-6 col-12">
																				<p class="image-right text-muted ml-2">and more ...</p>
																				<img class="image-right" src="../assets/img/logo/mastercard.svg">																	
																				<img class="image-right" src="../assets/img/logo/visa.svg">	
																			</div>
																		</div>		
																</li>
														</ul>
												</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="col-lg-4 col-md-12">
							<div class="grand-totall bg-white">
								<div class="title-wrap">
									<h4 class="cart-bottom-title section-bg-gary-cart">
										Total
									</h4>
								</div>
								<h5>
									<template v-if="event.billing_mode == 'bill_customer' || event.billing_mode == 'split_bill'">
										<p>Subtotal <span>KSh {{event.subtotal}}</span></p>
										<p>Processing Fee <span>KSh {{event.commission_amount}}</span></p><hr class="m-4" />
									</template>
									<h6>Grandtotal <span>KSh {{event.total_revenue}}</span></h6>
								</h5>

								<span
									>Your personal data will be used to process your order, support
									your experience throughout this website and for other purposes
									described in our
									<router-link class="text-primary" to="/privacy">privacy policy.</router-link>
								</span>

								<a class="golden-btn mt-4 btn-block rounded" @click="buyTicket">
									<span class="btn_text text-white">Buy Ticket</span>
								</a>
							</div>
						</div>
					</div>	
				</template>

				<template v-else>
					<div class="row">
						<div class="col-lg-12">
							<h5 class="text-danger my-4"><i class="fa fa-exclamation fa-lg px-2"></i>Checkout is empty. Go back to <router-link class="text-primary" to="/">home</router-link> page</h5>
						</div>
					</div>
				</template>

				<b-modal id="payment-steps-modal" centered title="Lipa na Mpesa" hide-footer no-close-on-esc no-close-on-backdrop>
					<h4 class="mb-4">Payment steps</h4>
					<ol>
						<li class="my-2">Request payment prompt below</li>
						<li class="my-2">A Payment prompt is sent to the phone number provided</li>
						<li class="my-2">Enter your Mpesa PIN on your mobile phone</li>
						<li class="my-2">Ticket Mojo automatically receives your payment</li>
						<li class="my-2">Your tickets are generated and send to phone/email</li>
					</ol>

					<a class="golden-btn mt-4 btn-block rounded" @click="mpesaSTKCheckout">
						<span class="btn_text text-white">Request Payment</span>						
					</a>
				</b-modal>

				<b-modal id="payment-send-request" @hidden="modalClosed" centered title="Pay for ticket" hide-footer no-close-on-esc no-close-on-backdrop>
					<div>
						<i class="fa fa-spinner fa-spin product-loader spin-centered mb-4" v-if="paymentLoader"></i>
						<i class="fa fa-check-circle status-ic centered text-success" v-if="paymentSuccessIC"></i>
						<i class="fa fa-times-circle status-ic centered text-danger" v-if="paymentErrorIC"></i>
						<h5 class="mt-2 text-center">{{message}}</h5>	
					</div>
				</b-modal>
			</div>
		</div>

    <Footer />
  </div>
</template>

<script>
import { mapState, mapGetter, mapActions } from "vuex";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import Tickets from "../apis/tickets";
import Payments from "../apis/payments";
import { config } from '../util/config'

export default {
  name: "Checkout",

  components: {
    Header,
    Footer,
  },

  data() {
    return {
		selected: '',

		modal: true,

		loader: true,
		slide: 0,
		sliding: null,

		ticketTypes: [],
		tickets: [],

		grandtotal: 0,
		quantitySold: 0,

		paymentLoader: true,
		paymentSuccessIC: false,		
		paymentErrorIC: false,

		mpesaCheckout: false,
		pesapalCheckout: false,
		paymentOption: null,
		ticketGenerated: false,
		phone: null,
		message: null,
		count: 0,

		merchantRequestID: null,
		checkoutRequestID: null,

		interval: null,

		paymentData: {
			tx_ref: this.generateReference(),
			amount: this.$store.getters.grand_total,
			currency: 'KES',
			payment_options: 'card',
			redirect_url: '',
			customer: {
				name: "",
				email: "",
				phone_number: "",
			} ,
			customizations: {
				title: 'TicketMojo',
				description: 'TicketMojo Card Checkout',
				logo: config.backendURL + '/img/logo-black.png'
			},
			callback: this.makePaymentCallback,
			onclose: this.closedPaymentModal
		}
    };
  },

  computed: {
    ...mapState(["serverUrl", "event"]),
    ...mapState("auth", ["userData"]),
  },

  created: function () {
   		if(this.userData != null) {
			this.paymentData.customer.name = this.userData.user.name
			this.paymentData.customer.email = this.userData.user.email
			this.paymentData.customer.phone_number = this.userData.user.phone_number
		}
  },

	mounted() {
		//
	},

  methods: {
		...mapActions(["addEventOrder"]),

		changePaymentMethod(type) {
			if(type == 'mpesa') {
				this.mpesaCheckout = true
				this.pesapalCheckout = false
				
			}
			else {
				this.mpesaCheckout = false
				this.pesapalCheckout = true
			}

			this.paymentOption = type
		},  
		
		buyTicket() {
			this.phone = this.paymentData.customer.phone_number

			if(this.paymentData.customer.name != "" && 
				this.paymentData.customer.email != "" && 
				this.phone != "") {
					if(String(this.phone).length == 10 && (this.phone.slice(0,2) == "07" || this.phone.slice(0,2) == "01")) {
						if(this.paymentOption != null) {
							this.phone = this.paymentData.customer.phone_number.replace(/07/i, "2547")
							
							if(this.pesapalCheckout) {
								this.pesapalRequestPayment()							
							}
							else if(this.mpesaCheckout) {
								this.mpesaSteps()
							}
						}
						else {
							alert("Please pick a payment option")
						}	
					}
					else {
						alert("Invalid phone number. Format 07XXXXXXXX")
					}	
			}
			else {
				alert("Please fill in the billing details")
			}			
		},

		pesapalRequestPayment() {
			var that = this

			this.$bvModal.hide('payment-steps-modal')	
			this.$bvModal.show('payment-send-request')	

			this.message = "Sending request ..."

			var data = {}

			data.event_id = this.event.event_id
			data.full_names = this.paymentData.customer.name
			data.email = this.paymentData.customer.email			
			data.amount = this.event.total_revenue
			data.phone_number = this.phone
			data.tickets = []

			this.event.tickets.forEach(function (ticket) {
				var ticketObj = {};

				ticketObj.ticket_type_id = ticket.id;
				ticketObj.quantity = ticket.quantity;

				data.tickets.push(ticketObj);
			});

			if(this.userData == null)
				data.user_id = 0				
			else 
				data.user_id = this.userData.user.id

			clearInterval(that.interval)

			Payments.pesapalRequest(data)
				.then((response) => {
					if(response.data?.redirect_url) {
						window.open(response.data?.redirect_url, '_blank')
						that.message = "Request sent, waiting for payment confirmation"
						that.interval = setInterval(() => that.queryPesapalPayment(response.data), 5000)
					}					
				})
				.catch(function (err) {
					that.paymentError()	
				});   
		},

		makePaymentCallback(response) {
				var that = this

				if(response.status == "successful") {
					that.closePaymentModal()	

					that.$bvModal.show('payment-send-request')	
					that.message = "Confirming your card payment ..."

					that.flutterwaveComplete(response, "success")
				}
				else {
					that.flutterwaveComplete(response, "failed")
				}
		},

		flutterwaveComplete(response, status) {
			var that = this			
			var data = {}

			data.status = status
			data.amount = this.event.total_revenue
			data.phone_number = that.phone
			data.transaction_id = response.transaction_id				

			Payments.flutterwaveCallback(data)
				.then((response) => {
					if(response.data == "success") {
						that.paymentSuccess()	
					}
					else {
						console.log("Flutterwave callback failed")
						that.paymentError()
					}					
				})
				.catch(function (err) {
					console.log("Flutterwave callback failed")
					that.paymentError()
				});
		},
		
		generateReference(){
		let date = new Date()
		return date.getTime().toString();
		},

		show() {
			this.$bvModal.show('payment-send-request')	
			this.message = "Sending request to mobile"
		},

		mpesaSteps() {
			this.$bvModal.show('payment-steps-modal')	
			this.paymentLoader = true
			this.paymentErrorIC = false
			this.paymentSuccessIC = false
		},

		mpesaSTKCheckout() {
			var that = this

			this.$bvModal.hide('payment-steps-modal')	
			this.$bvModal.show('payment-send-request')	

			this.message = "Sending request to mobile"

			var data = {}

			data.event_id = this.event.event_id
			data.full_names = this.paymentData.customer.name
			data.email = this.paymentData.customer.email			
			data.amount = this.event.total_revenue
			data.phone_number = this.phone
			data.tickets = []

			this.event.tickets.forEach(function (ticket) {
				var ticketObj = {};

				ticketObj.ticket_type_id = ticket.id;
				ticketObj.quantity = ticket.quantity;

				data.tickets.push(ticketObj);
			});

			if(this.userData == null)
				data.user_id = 0				
			else 
				data.user_id = this.userData.user.id

			Payments.request(data)
				.then((response) => {
					that.message = "Request sent, waiting for payment confirmation"
					that.interval = setInterval(() => that.queryMpesaPayment(response.data), 5000)
				})
				.catch(function (err) {
						
				});
		},

		queryMpesaPayment(resp) {
			var that = this

			that.count +=1
			
			var data = {}

			data.merchant_request_id = resp.merchant_request_id
			data.checkout_request_id = resp.checkout_request_id			

			Payments.query(data)
				.then((response) => {
					var payment = response.data

					if(payment.payment_status == "pending") {					
						if(that.count > 10) {
							clearInterval(that.interval)
							console.log("Mpesa interval complete")
							that.paymentError()
						}					
					}
					else if(payment.payment_status == "success") {
						if(!that.ticketGenerated) {
							clearInterval(that.interval)
							that.paymentSuccess()
						}
					}
					else {
						clearInterval(that.interval)
						console.log("Mpesa unknown payment status")
						that.paymentError()
					}
				})
				.catch(function (err) {
						
				});
		},

		queryPesapalPayment(resp) {
			var that = this

			that.count +=1
			
			var data = {}

			data.merchant_request_id = resp.merchant_request_id
			data.checkout_request_id = resp.checkout_request_id			

			Payments.query(data)
				.then((response) => {
					var payment = response.data

					if(payment.payment_status == "pending") {					
						if(that.count > 20) {
							clearInterval(that.interval)
							that.paymentError()
						}					
					}
					else if(payment.payment_status == "success") {
						if(!that.ticketGenerated) {
							clearInterval(that.interval)
							that.paymentSuccess()
						}
					}
					else {
						clearInterval(that.interval)
						that.paymentError()
					}
				})
				.catch(function (err) {
						
				});
		},

		paymentSuccess() {
			this.paymentLoader = false
			this.paymentSuccessIC = true
			this.ticketGenerated = true
			this.message = "Payment received successfully. You will receive your tickets via SMS and Email momentarily"
		},

		paymentError() {
			var that = this

			that.paymentLoader = false
			that.paymentErrorIC = true
			that.message = "Error with payment. Please try again later"
		},

		modalClosed() {
			clearInterval(this.interval)				
		}
  },
};
</script>
